import { useMemo } from 'react';
import { useModal } from '@ebay/nice-modal-react';
import { ColumnDef } from '@tanstack/react-table';
import { Logs, Search } from 'lucide-react';
import useWebhooks from '@/hooks/useWebhooks';
import { IWebhookAttempt } from '@/types';
import DataTable from '../DataTable/DataTable';
import Section from '../Section';
import Time from '../Time';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';

const Webhooks = () => {
  const webhooks = useWebhooks();
  const data = useMemo(() => webhooks.data || [], [webhooks.data]);
  const drawer = useModal('webhook-drawer');

  const columns: ColumnDef<IWebhookAttempt>[] = useMemo(
    () => [
      {
        accessorKey: 'destination',
        header: 'Webhook URL',
        accessorFn: (row) => row.webhook.destination || 'N/A',
      },
      {
        id: 'status',
        header: 'Status',
        accessorFn: (row) => row.status || 'N/A',
        cell: ({ row }) => (row.original.status ? <Badge>{row.original.status}</Badge> : 'N/A'),
      },
      {
        id: 'response_code',
        header: 'Response Code',
        accessorFn: (row) => row.response_code || 'N/A',
        cell: ({ row }) =>
          Number(row.original.response_code) > 200 && Number(row.original.response_code) < 300 ? (
            <Badge className="bg-green-600">{row.original.response_code}</Badge>
          ) : (
            <Badge variant={'destructive'}>{row.original.response_code}</Badge>
          ),
      },
      {
        id: 'attempted_at',
        header: 'Last Attempted At',
        accessorFn: (row) => row.attempted_at || 'N/A',
        cell: ({ row }) => <Time>{row.original.attempted_at}</Time>,
      },
      {
        header: 'Actions',
        cell: ({ row }) => (
          <Button
            onClick={() => {
              drawer.show({ webhookAttempt: row.original });
            }}
          >
            <Search />
            View
          </Button>
        ),
      },
    ],
    [],
  );

  return (
    <>
      <div className="flex items-center justify-between gap-2 mb-8">
        <div className="flex items-center gap-2 mb-4">
          <Logs />
          <div className="text-lg font-bold">Webhook Logs</div>
        </div>
      </div>

      <Section>
        <DataTable data={data} columns={columns} model={webhooks} />
      </Section>
    </>
  );
};

export default Webhooks;
